import React from 'react';

import DatasetColumnLabel from 'components/DatasetColumnLabel';

const CategoricalOption = () => (
  <DatasetColumnLabel type="categorical">
    <span>Categorical</span>
  </DatasetColumnLabel>
);

export default CategoricalOption;
